export default {
      id: "angleDoubleLeft-usage",
      viewBox: "0 0 14 14",
      url: "assets/" + "sprite.svg#angleDoubleLeft-usage",
      toString: function () {
        return this.url;
      }
    }